import React from "react";
import { useForm, Controller } from "react-hook-form";
import Layout from "app/components/layouts";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import { useSendOtp } from "app/hooks/applicant/useSendOtp";
import ContinueButton from "app/components/common/buttons/Continue";
import { useNavigate } from "react-router-dom";
import PhoneNumberInput from "app/components/common/inputs/PhoneNumberInput";
import { isValidPhoneNumber } from "react-phone-number-input";
import { handleApiError } from "app/utils/handleApiError";
import { toast } from "react-hot-toast";

interface FormData {
  phoneNumber: string;
}

const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const { mutate: sendOtp, isPending } = useSendOtp();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    let phoneNumber = data.phoneNumber?.trim();

    // Ensure the number starts with +
    if (phoneNumber && !phoneNumber.startsWith("+")) {
      phoneNumber = `+${phoneNumber}`;
    }
    sendOtp(
      { phoneNumber },
      {
        onSuccess: (data) => {
          const { applicantId, success, message } = data;
          if (
            !success &&
            message === "Your application is already completed."
          ) {
            toast.success(message);
          } else {
            toast.success("OTP has been sent successfully");
          }
          if (data && success) {
            navigate(`/otp/${applicantId}`, { state: { phoneNumber } });
          }
        },
        onError: (err: any) => {
          handleApiError(err);
        },
      }
    );
  };

  return (
    <>
      <Layout>
        <div className="w-[90%] sm:w-[30%] mx-auto text-center  sm:px-2 mt-8">
          <h1 className="font-Poppins text-[24px] sm:text-[40px] text-primary font-bold mb-4">
            Sign In
          </h1>
          <p className="font-Mulish font-normal text-lightBlue text-base mb-8">
            Please sign in to your account
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className="text-left">
            <div className="text-left">
              <label className="block font-Mulish text-base font-normal text-lightBlue mb-1">
                Phone number
              </label>
              <Controller
                name="phoneNumber"
                control={control}
                rules={{
                  required: "Phone number is required",
                  validate: (value) =>
                    isValidPhoneNumber(value || "") ||
                    "Please enter a valid phone number",
                }}
                render={({ field: { onChange, value } }) => (
                  <PhoneNumberInput
                    value={value}
                    onChange={onChange}
                    error={!!errors.phoneNumber}
                  />
                )}
              />
            </div>

            {errors.phoneNumber && (
              <ErrorsMessage title={errors.phoneNumber.message} />
            )}

            <div className="mt-12 text-center">
              <ContinueButton
                className="w-full sm:!w-[96%]   mx-auto"
                type="submit"
                loading={isPending}
              >
                Send OTP
              </ContinueButton>
            </div>
          </form>
        </div>
      </Layout>
    </>
  );
};

export default SignIn;
